
import { memo } from "react";
import {
  column,
  dynamicTable,
} from "../CommonForm/CommonFormInterface";

const DynamicTable = ({
  field,
  bodyData = []
}: {
  field: dynamicTable;
  bodyData: any[]
}) => {
  const getData = (fields:any, item: any) =>{
     if (!fields || !item) return undefined;
      if (!fields.field) {
        return item[fields.key];
      }
      const nextItemLayer = item[fields.key];
      return getData(fields.field, nextItemLayer);
  }
  return (
    <table className={`table ${field?.className ?? ""}`} style={field?.style}>
      {field?.properties?.showHeaders && field?.columns && field?.columns?.length && (
        <thead>
          <tr>
            {field?.columns?.map((column: column, columnIdx: number) => {
              return <th key={column?.field} style={{...(field?.thStyle??{}), ...(column?.thStyle??{})}}>{column?.label}</th>;
            })}
          </tr>
        </thead>
      )}
      {bodyData?.length > 0 && (
        <tbody>
          {bodyData.map((item: any, dataIdx: number) => (
            <tr key={dataIdx}>
              {field?.columns && field?.columns?.length && field?.columns?.map((column: column, columnIdx: number) =>{
                if(column?.columnAs === 'th'){
                  return <th key={column?.field + dataIdx} style={{...(field?.thStyle??{}), ...(column?.thStyle??{})}}>{item?.[column?.field]}</th>
                }
                return <td key={column?.field + dataIdx} style={{...(field?.tdStyle??{}), ...(column?.tdStyle??{})}}>{column?.dynamicField?getData(column?.dynamicField,item):item?.[column?.field]}</td>
              })}
            </tr>
          ))}
        </tbody>
      )}
    </table>
  );
};

export default memo(DynamicTable);
